import axios, { AxiosResponse } from 'axios';

import { AdyenCreditCardFormData } from '../components/Adyen/Forms/hooks/useAdyenState.static';

import { BaseRequestParameters, makePostWithData, makePostWithParameters } from './api';
import { captureException } from './sentryService';

export type PSP = 'BRAINTREE' | 'ADYEN';

export interface BaseCreditCardRequestParameters extends BaseRequestParameters {
  psp: PSP;
}

export interface SingleCreditCardRequestParameters extends BaseCreditCardRequestParameters {
  creditCardIdentifier: string;
}

export interface BraintreeStoreCreditCardArguments extends BaseRequestParameters {
  psp: 'BRAINTREE';
  braintreeNonce: string;
  braintreeLastFourNumber: string;
  braintreeCardholderName: string;
  braintreeExpirationMonth: string;
  braintreeExpirationYear: string;
  braintreeCardType: string;
  braintreeStoreCard: boolean;
  braintreeBinData: string;
  braintreeBin: string;
}

export const selectCreditCard = makePostWithParameters<SingleCreditCardRequestParameters, boolean>(
  '/checkout/editpayment/selectZppCreditCard',
);

export const deleteCreditCard = makePostWithParameters<
  SingleCreditCardRequestParameters,
  string | null
>('/checkout/editpayment/deleteZppCreditCard');

export const deleteAllCreditCards = makePostWithParameters<
  BaseCreditCardRequestParameters,
  boolean
>('/checkout/editpayment/deleteAllZppCreditCards');

export const storeBraintreeCreditCard = async ({
  csrfToken,
  ...params
}: BraintreeStoreCreditCardArguments) => {
  try {
    const result: AxiosResponse<boolean> = await axios({
      method: 'post',
      url: '/checkout/editpayment/storeZppCreditCardInSession',
      params,
      headers: { 'X-CSRF-Token': csrfToken },
    });
    if (!result) {
      throw new Error('Internal error while saving Braintree credit card');
    }
    return result;
  } catch (error) {
    throw captureException({ error });
  }
};

export const storeAdyenCreditCard = makePostWithData<AdyenCreditCardFormData, boolean>(
  '/checkout/editpayment/storeAdyenCreditCardInSession',
);
